const FUNCTIONALITY = "how_did_you_hear_about_us";

export const resolveFoundOutAboutPlatform = (storedValue, platform, currentLocale) => {
    if (!storedValue) return null;
    const options = platform?.functionalities_extras?.[FUNCTIONALITY]?.options || [];
    const match = options.find(o => o?.pt === storedValue);
    if (!match) return storedValue;
    const lang = (currentLocale || "").split("-")[0];
    return match[lang] || match.en || match.pt || storedValue;
};
